module.exports = __webpack_public_path__ + "img/check-success-icons.svg";